<div class="share-modal-backdrop" (click)="close()">
  <div class="share-modal-dialog" (click)="stopPropagation($event)">
    <div class="share-modal-content">
      <button
        type="button"
        class="share-modal-close"
        (click)="close()"
        aria-label="Close"
      >
        &times;
      </button>

      <div class="share-modal-icon">
        <img src="/assets/images/fry-bucket.svg" alt="" />
      </div>

      <h4 class="share-modal-title">Share link</h4>
      <p class="share-modal-subtitle">
        Share this standard or equipment link with your colleagues.
      </p>

      <div class="share-modal-item-card">
        <div class="share-modal-item-icon">
          <img [src]="itemIcon" alt="" />
        </div>
        <div class="share-modal-item-text">
          <div class="share-modal-item-title">{{ itemTitle }}</div>
          <div class="share-modal-item-subtitle">{{ itemSubtitle }}</div>
        </div>
      </div>

      <div class="share-modal-section-label">Share via</div>
      <div class="share-modal-actions">
        <button
          type="button"
          class="share-modal-action"
          [class.is-active]="copied"
          (click)="copyLink()"
        >
          <span class="share-modal-action-icon-box copy-link-box">
            <img *ngIf="!copied" src="/assets/images/copy link icon.svg" alt="" />
            <svg
              *ngIf="copied"
              width="20"
              height="20"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M5.25 9.25L7.75 11.75L12.75 6.25"
                stroke="#1E8E4E"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="share-modal-action-label">{{
            copied ? "Copied!" : "Copy Link"
          }}</span>
        </button>

        <button type="button" class="share-modal-action" (click)="shareViaEmail()">
          <span class="share-modal-action-icon-box email-box">
            <img src="/assets/images/mail icon.svg" alt="" />
          </span>
          <span class="share-modal-action-label">Email</span>
        </button>

        <button type="button" class="share-modal-action" (click)="shareViaTeams()">
          <span class="share-modal-action-icon-box teams-box">
            <img src="/assets/images/teams icon.svg" alt="" />
          </span>
          <span class="share-modal-action-label">Teams</span>
        </button>

        <button type="button" class="share-modal-action" (click)="shareViaSharePoint()">
          <span class="share-modal-action-icon-box sharepoint-box">
            <img src="/assets/images/sharepoint icon.svg" alt="" />
          </span>
          <span class="share-modal-action-label">SharePoint</span>
        </button>
      </div>

      <div class="share-modal-section-label share-modal-link-label">Link</div>
      <div class="share-modal-link-box" [class.is-copied]="copied">
        <img
          src="/assets/images/copy link icon.svg"
          alt=""
          class="share-modal-link-icon"
        />
        <span class="share-modal-link-text" [title]="shareUrl">{{
          shareUrl
        }}</span>
      </div>

      <p class="share-modal-footnote">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <rect
            x="2.5"
            y="5.5"
            width="7"
            height="5"
            rx="1"
            stroke="#696F77"
            stroke-width="1"
          />
          <path d="M4 5.5V4a2 2 0 014 0v1.5" stroke="#696F77" stroke-width="1" />
        </svg>
        Only people signed in to GRS can open this link.
      </p>
    </div>
  </div>
</div>
